// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "label[data-v-6a858780] {\n  color: #4f4f4f !important;\n  font-size: 11px;\n}\n.card-header[data-v-6a858780] {\n  border-bottom: 0;\n  padding: 3rem 1.5rem;\n}\n.card-body[data-v-6a858780] {\n  height: calc(100vh - 260px);\n  overflow: auto;\n}\n@media (max-width: 768px) {\n.card-body[data-v-6a858780] {\n    height: auto;\n}\n}", ""]);
// Exports
module.exports = exports;
